var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockChartFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.6677C4.36867 10.6677 4.66667 10.9657 4.66667 11.3344V13.3344C4.66667 13.703 4.36867 14.001 4 14.001H2.66667C2.298 14.001 2 13.703 2 13.3344V11.3344C2 10.9657 2.298 10.6677 2.66667 10.6677H4ZM8.66667 9.33438C9.03533 9.33438 9.33333 9.63305 9.33333 10.001V13.3344C9.33333 13.703 9.03533 14.001 8.66667 14.001H7.33333C6.96467 14.001 6.66667 13.703 6.66667 13.3344V10.001C6.66667 9.63305 6.96467 9.33438 7.33333 9.33438H8.66667ZM13.3333 8.00105C13.702 8.00105 14 8.29971 14 8.66771V13.3344C14 13.703 13.702 14.001 13.3333 14.001H12C11.6313 14.001 11.3333 13.703 11.3333 13.3344V8.66771C11.3333 8.29971 11.6313 8.00105 12 8.00105H13.3333ZM9.5292 1.62665L13.4312 2.50531C13.7432 2.57665 14.0265 2.89865 13.9352 3.30265L13.0552 7.20465L11.7545 6.91198L12.2799 4.58198L2.6992 10.2386L2.02187 9.08998L11.5692 3.45265L9.23653 2.92731L9.5292 1.62665Z",
    fill: "#FF6200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockChartFilled);
export default __webpack_public_path__ + "static/media/stock-chart-filled.73ebb4c20fc0cfc0ed0901a1b307bc04.svg";
export { ForwardRef as ReactComponent };